import $ from "jquery";

const {registerBlockType} = wp.blocks;
const {RichText, MediaUpload, MediaUploadCheck, URLInputButton} = wp.blockEditor;
const {useEffect} = wp.element;
const {Button} = wp.components;

import simpleSlider from '../../../resources/scripts/module/simple-slider';

registerBlockType('mailmetrics/quote-carousel', {
  title: 'Quote Carousel',
  icon: 'format-quote',
  category: 'layout',
  attributes: {
    uniqueId: {
      type: 'string',
      default: '',
    },
    quotes: {
      type: 'array',
      default: [],
      source: 'query',
      selector: '.quotes-carousel-slider-item',
      query: {
        quote: {
          type: 'string',
          source: 'text',
          selector: '.quotes-item-quote',
        },
        name: {
          type: 'string',
          source: 'text',
          selector: '.quotes-item-person-name',
        },
        role: {
          type: 'string',
          source: 'text',
          selector: '.quotes-item-person-role',
        },
        imageUrl: {
          type: 'string',
          source: 'attribute',
          attribute: 'src',
          selector: '.quotes-item-image',
        },
        caseStudyUrl: {
          type: 'string',
          source: 'attribute',
          attribute: 'href',
          selector: '.quotes-item-read-more'
        },
        caseStudyText: {
          type: 'string',
          source: 'text',
          selector: '.quotes-item-read-more',
          default: 'Read more',
        }
      }
    }
  },

  edit: ({attributes, setAttributes}) => {
    const {quotes, uniqueId} = attributes;

    if (!uniqueId) {
      const generatedId = 'quotes-slider-' + Date.now();
      setAttributes({uniqueId: generatedId});
    }

    const debouncedUpdateQuotes = newQuotes => setAttributes({quotes: newQuotes});

    useEffect(() => {
      if (quotes.length) {
        simpleSlider();
      }
    }, [quotes.length]);

    const handleUpdateQuotes = (newQuotes) => {
      debouncedUpdateQuotes(newQuotes);
    };

    const updateQuote = async (newQuote, index) => {
      const newQuotes = quotes.map((quote, i) => {
        if (i === index) {
          return {...quote, ...newQuote};
        }
        return quote;
      });
      handleUpdateQuotes(newQuotes);
    };

    const reinitSlick = () => {
      const slider = $(`#${uniqueId}`);
      if (slider.hasClass('slick-initialized')) {
        slider.slick('unslick');
      }
    };

    const addQuote = async () => {
      const newQuotes = [...quotes, {quote: '', name: '', role: '', imageUrl: ''}];
      handleUpdateQuotes(newQuotes);
      reinitSlick();
    };

    const removeQuote = async (index) => {
      const newQuotes = quotes.filter((_, i) => i !== index);
      handleUpdateQuotes(newQuotes);
      reinitSlick();
    };

    return (
      <div className="quotes-section">
        <div className="inner">
          <div className="quotes-carousel-container">
            <div className="quotes-carousel-slider">
              <div data-slider="simple" id={uniqueId} className="quotes-carousel-slider-items">
                {quotes.map((quote, index) => (
                  <div className="quotes-carousel-slider-item" key={index}>
                    <RichText
                      tagName="p"
                      className="quotes-item-quote"
                      value={quote.quote}
                      onChange={(newQuote) => updateQuote({quote: newQuote}, index)}
                      placeholder="Enter quote..."
                    />
                    <div className="quotes-item-bottom">
                      <div className="quotes-item-person">
                        <RichText
                          tagName="span"
                          className="quotes-item-person-name"
                          value={quote.name}
                          onChange={(newName) => updateQuote({name: newName}, index)}
                          placeholder="Enter name..."
                        />
                        <RichText
                          tagName="span"
                          className="quotes-item-person-role"
                          value={quote.role}
                          onChange={(newRole) => updateQuote({role: newRole}, index)}
                          placeholder="Enter role..."
                        />
                      </div>
                      <MediaUploadCheck>
                        <MediaUpload
                          onSelect={(media) => updateQuote({imageUrl: media.url}, index)}
                          allowedTypes={['image']}
                          value={quote.imageUrl ? [quote.imageUrl] : []}
                          render={({open}) => (
                            <Button onClick={open} isDefault>
                              {quote.imageUrl ? 'Replace Image' : 'Select Image'}
                            </Button>
                          )}
                        />
                      </MediaUploadCheck>
                      {quote.imageUrl && (
                        <img src={quote.imageUrl} alt={`${quote.name}`}/>
                      )}
                    </div>
                    <a href="#" className={'quotes-item-read-more'}>
                      <RichText
                        tagName="span"
                        value={quote.caseStudyText}
                        onChange={(newText) => updateQuote({caseStudyText: newText}, index)}
                        placeholder="Enter case study text..."
                      />
                      <URLInputButton
                        url={quote.caseStudyUrl}
                        onChange={(newUrl) => updateQuote({caseStudyUrl: newUrl}, index)}
                      />
                    </a>
                    <Button isDestructive onClick={() => removeQuote(index)}>
                      Remove Quote
                    </Button>
                  </div>
                ))}
              </div>
              <Button isDefault onClick={addQuote}>Add Quote</Button>
            </div>
          </div>
        </div>
      </div>
    );
  },

  save: ({attributes}) => {
    return (
      <div className="quotes-section">
        <div className="inner">
          <div className="quotes-carousel-container">
            <div className="quotes-carousel-slider">
              <div data-slider="simple" className="quotes-carousel-slider-items">
                {attributes.quotes && attributes.quotes.map((quote) => (
                  <div className="quotes-carousel-slider-item">
                    <RichText.Content
                      tagName="p"
                      className={'quotes-item-quote'}
                      value={quote.quote}
                    />
                    <div className="quotes-item-bottom">
                      <div className="quotes-item-person">
                        <RichText.Content
                          tagName="span"
                          className={'quotes-item-person-name'}
                          value={quote.name}
                        />
                        <RichText.Content
                          tagName="span"
                          className={'quotes-item-person-role'}
                          value={quote.role}
                        />
                      </div>
                      {quote.imageUrl && (
                        <img className="quotes-item-image" src={quote.imageUrl} alt={quote.name}/>
                      )}
                    </div>
                    <a href={quote.caseStudyUrl} className="quotes-item-read-more">
                      <RichText.Content
                        tagName="span"
                        value={quote.caseStudyText}
                      />
                    </a>
                  </div>
                ))}
              </div>
            </div>
            <div className="quotes-carousel-slider-pagination"/>
          </div>
        </div>
      </div>
    );
  }
});
